import { TooltipProvider } from '@radix-ui/react-tooltip'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { ReactQueryClientProvider } from '../../features/react-query-provider/ReactQueryClientProvider'
import '../lib/rum'
import { styled } from '../lib/stitches'
import { Player } from './player/Player'

const PlayerWrapper = styled('div', {
  height: '100vh',
  width: '100%'
})

const App: React.FC = () => {
  return (
    <TooltipProvider>
      <ReactQueryClientProvider>
        <PlayerWrapper>
          <Player />
        </PlayerWrapper>
      </ReactQueryClientProvider>
    </TooltipProvider>
  )
}

const app = document.getElementById('app')
const root = createRoot(app)
root.render(<App />)
